import { request2 } from "../request2";
import config from '../config'
import _ from 'lodash'
let stockListObjectOriginKeys = { "id": "id", "lxNo": "lx_no", "nameDisplayEn": "name_display_EN", "vintage": "vintage", "isSpecial": "is_special", "bottlePerCase": "bottle_per_case", "bottleSize": "bottle_size", "numberOfCase": "number_of_case", "sourceId": "source_id", "totalAmountGbp": "total_amount_gbp", "exchangeRate": "exchange_rate", "paymentStatus": "payment_status", "paymentDate": "payment_date", "bank": "bank", "amount": "amount", "remarks": "remarks", "arrivalDate": "arrival_date", "arrivalCheckby": "arrival_checkby", "approver": "approver", "deliveryVendor": "delivery_vendor", "deliverSn": "deliver_SN", "customerName": "customer_name", "remarksDelivery": "remarks_delivery", "refundStatus": "refund_status", "refundAmount": "refund_amount", "refundProof": "refund_proof", "refundReason": "refund_reason" };
export const getStockList = (params) => {
  return request2({
    method: 'post',
    url: '/admintwo/transactionUK/getAll',
    params
  }, {
    config: {
      baseURL: config.apiURL
    }
  }).then(res => {
    return {
      list: res.data?.map(tem => {
        tem.payment_status = tem.payment_status ? true : false;
        tem.refund_status = tem.refund_status ? true : false;
        let obj = {};
        for (let key in tem) {
          obj[_.camelCase(key)] = tem[key]
        }
        return obj;
      }) || [],
      totalCount: res.message || 0
    }
  })
}

export const setStockItem = (params) => {
  let nparams = {};
  for (let key in params) nparams[stockListObjectOriginKeys[key]] = params[key];
  return request2({
    method: 'post',
    url: '/admintwo/transactionUK/modify',
    params: nparams
  }, {
    config: {
      baseURL: config.apiURL
    }
  })
}
export const delStockItem = (params) => {
  return request2({
    method: 'post',
    url: '/dashboard/transaction/cancel/' + params.id,
  }, {
    config: {
      baseURL: config.apiURL
    }
  })
}

